import { useMemo } from 'react';

import { useField } from 'react-final-form';

import type { FieldType, FormValues, Question, ReportType } from '../../../../shared/types';
import { getQuestions, getSubCategoriesOrQuestions, getSubSubCategoriesOrQuestions } from '../../../../shared/utils';

type Result = ModelHookResult<{
	parent: FieldType | undefined;
	questions: readonly Question[];
}>;

export function useQuestionField({ type }: { type: ReportType }): Result {
	const {
		input: { value: category },
	} = useField<FormValues['category']>('category', { subscription: { value: true } });
	const {
		input: { value: subCategory },
	} = useField<FormValues['subCategory']>('subCategory', { subscription: { value: true } });
	const {
		input: { value: subSubCategory },
	} = useField<FormValues['subSubCategory']>('subSubCategory', { subscription: { value: true } });

	const data = useMemo(() => {
		if (subSubCategory) {
			return {
				parent: subSubCategory,
				questions: getQuestions(type, subSubCategory),
			};
		}

		if (subCategory) {
			const subSubCategoriesOrQuestions = getSubSubCategoriesOrQuestions(type, subCategory);
			return {
				parent: subCategory,
				questions: subSubCategoriesOrQuestions.type === 'question' ? subSubCategoriesOrQuestions.value : [],
			};
		}

		if (category) {
			const subCategoriesOrQuestions = getSubCategoriesOrQuestions(type, category);
			return {
				parent: category,
				questions: subCategoriesOrQuestions.type === 'question' ? subCategoriesOrQuestions.value : [],
			};
		}
		return {
			parent: undefined,
			questions: [],
		};
	}, [category, subCategory, subSubCategory, type]);
	return { data };
}
